import { ref, watch } from '@vue/composition-api'
// import store from '@/store'

export default function useRefStatusHandler(props, emit) {
    // ------------------------------------------------
    // taskLocal
    // ------------------------------------------------
    const refStatusLocal = ref(JSON.parse(JSON.stringify(props.status.value)))
    const resetRefStatusLocal = () => {
      refStatusLocal.value = JSON.parse(JSON.stringify(props.status.value))
    }
    watch(props.status, () => {
      resetRefStatusLocal()
    })
  
    // ------------------------------------------------
    // isEventHandlerSidebarActive
    // * Clear form if sidebar is closed
    // ! We can hide it using @hidden event
    // ------------------------------------------------
    // watch(props.isEventHandlerSidebarActive, val => {
    //   // ? Don't reset event till transition is finished
    //   if (!val) {
    //     setTimeout(() => {
    //       clearForm.value()
    //     }, 350)
    //   }
    // })
  
    const onSubmit = () => {
      const refStatusData = JSON.parse(JSON.stringify(refStatusLocal))
  
      // * If event has id => Edit Event
      // Emit event for add/update event
      if (props.status.value.id) emit('update-ref-status', refStatusData.value)
      else emit('add-ref-status', refStatusData.value)
  
      // Close sidebar
      emit('update:is-add-new-ref-status-sidebar-active', false)
    }
  
  
    return {
      // fetchCategories,
      // fetchProducts,
      // fetchTags,
      // fetchPriorities,
      // fetchTeams,
      // fetchUsers,
      refStatusLocal,
      resetRefStatusLocal,
      onSubmit,
    }
  }